import { useParams, useHistory } from 'react-router-dom';
import { getAppRoutes } from 'Pages/App/App.constants';
import { RolePermission, useRoleDetail, useUpdateRole } from '../Roles.hooks';
import PermissionList, { RoleSubmitPayload } from './PermissionList';
import Spin from 'Components/Spin/Spin';
import { Notification } from 'Components';
import { useTranslation } from 'react-i18next';

function EditRole() {
	const { roleId } = useParams<{ roleId: string }>();
	const history = useHistory();
	const { role, permissionList = [], loading } = useRoleDetail(roleId);
	const [updateRole, { loading: updating }] = useUpdateRole();
	const { t } = useTranslation();

	const handleSubmit = async (values: RoleSubmitPayload) => {
		try {
			await updateRole(role, values);
			history.push(getAppRoutes().ROLES);
		} catch (error) {
			Notification.error({
				description: t('errorCodes.genericErrorMessage')
			});
		}
	};

	if (loading || !role || updating) return <Spin />

	return (
		<PermissionList		
			mode="edit"
			permissionList={permissionList}
			initialValues={{ roleId: role.id, roleName: role.role, description: role.description, isPrimary: role.isPrimary, permissions: role.permissions?.map((permission: RolePermission) => permission.id) ?? [] }}
			loading={updating}
			onCancel={() => history.goBack()}
			onSubmit={handleSubmit}
		/>
	);
}

export default EditRole;